// On réassigne state mais c'est prévu par redux-toolkit
import { jwtDecode, JwtPayload } from 'jwt-decode';
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginResponse } from '@services/Schemas/LoginSchema';
 
import { RootState } from './store';

interface UserData {
  UtilisateurId: number;
  ClientId: number;
  ApplicationModuleIds: number[];
  FeatureFlagIds: number[];
}

export interface McmJwtTokenContent extends JwtPayload {
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata': string,
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string[];

}


const sliceName = 'account';
export interface User {
  id: number;
  nom: string;
  prenom: string;
  token: string;
  roles: string[];
  idClient: number;
  applicationModuleIds: number[];
  featureFlagIds: number[];
}

export interface AccountSlice {
  user?: User;
}

const initialState: AccountSlice = {};

export const accountSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    logoff: (state) => {
      state.user = undefined;
      sessionStorage.clear();
    },
    loginSuccess: (state: AccountSlice, action: PayloadAction<LoginResponse>) => {
      const tokenContent = jwtDecode<McmJwtTokenContent>(action.payload.token);
      const roles = tokenContent['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? [];
      const userDataString = tokenContent['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'];
      const userData = JSON.parse(userDataString) as UserData;
      const applicationModuleIds = userData.ApplicationModuleIds ?? [];
      const featureFlagIds = userData.FeatureFlagIds ?? [];
      state.user = { ...action.payload, roles, applicationModuleIds, featureFlagIds };
      sessionStorage.setItem('account', JSON.stringify(state));
    },
    switchUser: (state: AccountSlice, action: PayloadAction<LoginResponse>) => {
      const tokenContent = jwtDecode<McmJwtTokenContent>(action.payload.token);
      const roles = tokenContent['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? [];
      const userDataString = tokenContent['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'];
      const userData = JSON.parse(userDataString) as UserData;
      const applicationModuleIds = userData.ApplicationModuleIds ?? [];
      const featureFlagIds = userData.FeatureFlagIds ?? [];
      state.user = { ...action.payload, roles, applicationModuleIds, featureFlagIds };
      sessionStorage.setItem('account', JSON.stringify(state));
    },
    /**
     * Updates the access token after a successful refresh.
     * Re-decodes the JWT to update roles and application module IDs.
     */
    updateToken: (state: AccountSlice, action: PayloadAction<string>) => {
      if (state.user) {
        const tokenContent = jwtDecode<McmJwtTokenContent>(action.payload);
        const roles = tokenContent['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? [];
        const userDataString = tokenContent['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'];
        const userData = JSON.parse(userDataString) as UserData;
        const applicationModuleIds = userData.ApplicationModuleIds ?? [];
        const featureFlagIds = userData.FeatureFlagIds ?? [];

        state.user.token = action.payload;
        state.user.roles = roles;
        state.user.applicationModuleIds = applicationModuleIds;
        state.user.featureFlagIds = featureFlagIds;

        sessionStorage.setItem('account', JSON.stringify(state));
      }
    },
  },
});

export const tryRecoverAccount = (): { account: AccountSlice } | undefined => {
  if (typeof sessionStorage === 'undefined') return undefined;
  const accountDansSession = sessionStorage.getItem('account');
  if (!accountDansSession) return undefined;
  const parsed = JSON.parse(accountDansSession) as AccountSlice;
  return { account: parsed };
};

export const { logoff, switchUser, loginSuccess, updateToken } = accountSlice.actions;
export const accountSliceName = accountSlice.name;

export const selectUser = (state: RootState) => state.account.user;

export default accountSlice.reducer;

